(function( $ ) {
$(document).ready(function () {

    let ajaxurl = "/wp-admin/admin-ajax.php",
        form = ".js-subscribe-ac",
        formEdit = ".js-popup-subscribe-preferences-edit form";
    const rules = {
        isEmpty: (v) => !v ? 'This field is required.' : '',
        isEmail: (v) => /^\S+@\S+\.\S+$/.test(v) ? '' : 'The email address entered is invalid.',
    };

    $('section').on('input', 'input[name="fname"]', function() {
        this.value = this.value.replace(/[^a-zа-яё\s]/gi, '');
    });

    $('section').on('input', 'input[name="lname"]', function() {
        this.value = this.value.replace(/[^a-zа-яё\s]/gi, '');
    });

    $(document).on("submit", form, function (event) {
        event.preventDefault();

        const fields = $(this).find('input[type="text"], input[type="email"], input[type="checkbox"]');
        const errors = [];
        let hasError = false;

        fields.each(function () {
            const input = $(this);
            const type = input.attr('type');
            const value = input.val();
            let error = '';

            if (type === 'text') error = rules.isEmpty(value);

            if (type === 'email') error = rules.isEmpty(value) || rules.isEmail(value);

            if (type === 'checkbox') error = !input.is(':checked');

            if (error) {
                input.next().next('.validation-message').text(error);
                input.parent().addClass('has-error');
            } else input.parent().removeClass('has-error');

            errors.push(error);
        });

        hasError = !errors.every((v) => !v);

        if (!hasError) {
            $(this).append('<input type="hidden" name="action" value="subscribe_ac">');
            const data = $(this).serialize();

            $.post(ajaxurl, data, (response) => {

                if (response.code === 200) {
                    $('.subscription-form-block').hide();
                    $('.subscription-thanks').show();
                    dataLayer.push({'event' : 'subscribe_to_our_newsletter'});
                } else if (response.code === 400) {
                    alert('Form has error');
                }
            });
        }
    });

    $('.js-subscribe-ac input[type="text"], .js-subscribe-ac input[type="email"], .js-subscribe-ac input[type="checkbox').on('input', function () {
        const input = $(this);
        const type = input.attr('type');
        const value = input.val();
        let error = '';

        if (type === 'text') error = rules.isEmpty(value);
        if (type === 'email') error = rules.isEmpty(value) || rules.isEmail(value);
        if (type === 'checkbox') error = !input.is(':checked');

        if (error) {
            input.next().next('.validation-message').text(error);
            input.parent().addClass('has-error');
        } else input.parent().removeClass('has-error');
    });

    $(document).on("change", formEdit, function () {
        UpdateCheckboxes();
    })

    $(document).on( 'gform_confirmation_loaded', function ( event, formId ) {
        const form = $('#gform_confirmation_wrapper_' + formId).closest('.js-subscription');
        if (form.length) form.children('h2, h3, p').hide();
    });

});

function UpdateCheckboxes() {
    let formEdit = ".js-popup-subscribe-preferences-edit form";
    let checkboxes = $(formEdit).find(".custom-checkbox input[type=checkbox]:not(:first)");
    let numOfCheckboxes = checkboxes.length;
    let numOfCheckedCheckboxes = checkboxes.filter(function () {
        return this.checked === true;
    }).length;

    //Check all
    $(formEdit).find(".custom-checkbox input[type=checkbox]:first").change(function () {
        $(formEdit).find(".custom-checkbox input[type=checkbox]").prop("checked", this.checked);
    });

    if (numOfCheckedCheckboxes === numOfCheckboxes) {
        $(formEdit).find(".custom-checkbox input[type=checkbox]:first").prop("checked", true);
    } else {
        $(formEdit).find(".custom-checkbox input[type=checkbox]:first").prop("checked", false);
    }
}

})( jQuery );

// subscription form on blog posts pages ( show-hide )
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.show-form-button')) {
        const showFormButton = document.querySelector('.show-form-button');
        showFormButton.addEventListener('click', function (e) {
            e.preventDefault();

            const subscriptionForm = document.querySelector('.subscription-form__body');
            if (subscriptionForm) subscriptionForm.classList.toggle('active');
        });
    }
});
